import React from "react";

import { css } from "@emotion/react";

import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { CSS_MQ } from "../../../styles/breakpoints";

import { PLPCard } from "./PLPCard";
import { ProductListingPageTile as StorefrontProductListingPageTile } from "@swo/storefront";

type PLPTileAction_Click = {
  tag: "click";
  onClick: () => void;
};

type PLPTileAction_Link = {
  tag: "link";
  href: {
    pathname: string;
    search: string | undefined;
  };
  metadata:
    | {
        productName: string;
        currencyCode: string;
        category: string;
        segmentKey: string;
      }
    | undefined;
};

type PLPTileAction = PLPTileAction_Click | PLPTileAction_Link;

export type PLPTile = Omit<StorefrontProductListingPageTile, "key"> & {
  action: PLPTileAction;
};

export const ProductListingPageTiles: ReactTFC<{
  isRefetching: boolean;
  tiles: Array<PLPTile>;
}> = ({ isRefetching: refetching, tiles }) => {
  return (
    <ul css={listStyles} className={refetching ? "refetching" : undefined}>
      {tiles.map(tile => {
        return (
          <PLPCard
            key={tile.id}
            action={tile.action}
            headline={tile.headline}
            isNew={tile.isNew}
            subheadlines={tile.subheadlines}
            asset={tile.asset}
            backgroundUrl={tile.backgroundUrl}
            text={tile.text}
          />
        );
      })}
    </ul>
  );
};

const listStyles = css`
  display: grid;

  grid-template-columns: 1fr;
  grid-gap: var(--plp-grid-gap);

  margin: 0;
  padding: 0;

  &.refetching {
    filter: opacity(0.2);
    transition-delay: 0.2s;
  }

  ${CSS_MQ.atLeastMd} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;
